import { gsap, Power4 } from 'gsap'
import { CustomEase} from 'gsap/CustomEase'
import { ExpoScaleEase } from "gsap/EasePack"
import { breakpoint } from './breakpoint-setup'

gsap.registerPlugin(CustomEase)

let timelineConfigSpeed = breakpoint('screen') > breakpoint('sm') ? (breakpoint('screen') > breakpoint('lg') ? 700 : 400) : 250


let timelineConfig = {
  speed : timelineConfigSpeed,
  animationDuration: 200,
  triggerElements: $('.timeline-element-trigger'),
  container: $('.timeline-container-screen-view')
}
let timelineEndPosition = 0

function setupTimeline()
{

  //CustomEase.create("custom", "M0,0,C0.318,0.168,0.082,0.045,0.312,0.164,0.44,0.23,0.896,0.862,1,1")
  //let customEase = CustomEase.create("custom", "M0,0,C0.318,0.168,0.289,0.159,0.514,0.286,0.638,0.356,0.896,0.862,1,1")
  let customEase = CustomEase.create("custom", "M0,0,C0.318,0.168,0.576,0.374,0.78,0.536,0.82,0.567,0.868,0.68,0.9,0.742,0.947,0.837,0.962,0.894,1,1")
  //let customEase = CustomEase.create("custom", "M0,0,C0.318,0.168,0.738,0.318,0.822,0.358,0.867,0.379,0.92,0.634,0.938,0.73,0.96,0.828,0.962,0.894,1,1")

  let timeline = gsap.timeline({
      'smoothChildTiming': true,
      ease: customEase
  })

  timeline.to('.menu-el .header-go-to-timeline', {className:"active header-go-to-timeline"}, 0)
  //hide scroll animation
  timeline.fromTo('.scroll-animation-container', { opacity: 1, scale: 1 }, {opacity: 0, scale: 0.1, ease: Power4.easeOut, duration: 35}, 100)
  timeline.fromTo('.mobile-go-to-timeline', { opacity: 1, scale: 1 }, {opacity: 0, scale: 0.1, ease: Power4.easeOut, duration: 10}, 5)

  //logo setup
  timeline.fromTo('.logo-c', { opacity: 0, scale: 0.2 }, {opacity: 1, scale: 1, ease: Power4.easeOut, duration: 5}, 0)

  //setup background color
  timeline.fromTo('.page-c', { backgroundColor: '#000000' }, { backgroundColor: '#B4B6B9', ease: Power4.easeOut, duration: 25, delay: 0}, 0)


  let timeline_elements = timelineConfig.triggerElements
  let containerHalfWidth = timelineConfig.container.width() / 2


  let element_key = 0
  let position = 0
  let element_width = 0
  let element_height = 0
  let previous_year = 0

  let screenWidth = $(window).width()
  let screenHeight = $(window).height()
  let screenHalfHeight = screenHeight / 2

  let startX, startY, endX, endY
  let previous_year_elements = 0

  timeline_elements.each(function(key, v){

    if($(this).hasClass('timeline-element-year')) {

      let this_year = $(this).attr('data-year')


      if(previous_year_elements > 0) {
        if(previous_year_elements < 4) {
          position += 80
        } else {
          position += 50
        }
      }

      $(this).attr('data-year-scroll', position)

      let speed = breakpoint('screen') > breakpoint('sm') ? 100 : 70 ;
      let imageStartWidth = breakpoint('screen') > breakpoint('sm') ? 200 : 30;
      let coefficient = breakpoint('screen') / 2000
      if(coefficient < 1) {
        coefficient = 1
      }

      let image = $(this).find('img')

      if(image.length) {

        if(previous_year_elements > 0) {
          timeline.fromTo(this, {opacity: 0},{opacity: 1, duration: 10}, position)
          timeline.fromTo(image,
            { width: 100 * coefficient },
            { width: 4000 * coefficient,
              ease:  CustomEase.create("custom", "M0,0 C0.276,0.016 0.424,0.056 0.5,0.1 0.678,0.202 0.731,0.341 0.8,0.5 0.84,0.592 0.828,0.57 1,1 "),
              duration: speed },
            position
          )
          timeline.to(this, {opacity:0, duration: 1}, position + speed)
        } else {

          timeline.fromTo(this, {opacity: 1},{opacity: 1, duration: 5}, position)
          timeline.fromTo(image,
            { width: imageStartWidth * coefficient },
            { width: 4000 * coefficient,
              ease:  Power4.easeIn,
              duration: speed },
            position
          )
          timeline.to(this, {opacity:0, duration: 1}, position + speed)
        }

      } else {

        if(previous_year_elements > 0) {
          timeline.fromTo(this, {opacity: 0},{opacity: 1, duration: 10}, position)
          timeline.fromTo(this,
            { y: 0, scale: 0.5 },
            { y: -screenHalfHeight ,scale: 20,
              ease:  CustomEase.create("custom", "M0,0 C0.276,0.016 0.424,0.056 0.5,0.1 0.678,0.202 0.731,0.341 0.8,0.5 0.84,0.592 0.828,0.57 1,1 "),
              duration: speed },
            position
          )
          timeline.to(this, {opacity:0, duration: 1}, position + speed)
        } else {

          timeline.fromTo(this, {opacity: 1},{opacity: 1, duration: 5}, position)
          timeline.fromTo(this,
            { y: 0, scale: 0.5 },
            { y: -screenHalfHeight ,scale: 20,
              ease:  CustomEase.create("custom", "M0,0 C0.276,0.016 0.424,0.056 0.5,0.1 0.678,0.202 0.731,0.341 0.8,0.5 0.84,0.592 0.828,0.57 1,1 "),
              duration: speed },
            position
          )
          timeline.to(this, {opacity:0, duration: 1}, position + speed)
        }

      }



      previous_year_elements = parseInt($(this).attr('data-elements'))



      //setup navigation
      $('.years-menu-el[data-year="'+this_year+'"]').attr('data-year-scroll', position)
      timeline.to('.years-menu-el[data-year="'+this_year+'"]', {className:"+=years-menu-el active"}, position)

      if(previous_year > 0) {
        timeline.to('.years-menu-el[data-year="'+previous_year+'"]', {className:"+=years-menu-el"}, position)
      }

      previous_year = this_year


    } else {

      element_width = $(this).width()
      element_height = $(this).height()
      let elementEndScale = 2.5
      let elementStartScale = 0.5

      let element_width_start_scaled = element_width * elementStartScale
      let element_height_start_scaled = element_height * elementStartScale

      let element_width_end_scaled = element_width * elementEndScale
      let element_height_end_scaled = element_height * elementEndScale

      let element_scale_end_width_diff = element_width_end_scaled - element_width
      let element_scale_end_height_diff = element_height_end_scaled - element_height

      let element_scale_start_width_diff = element_width - element_width_start_scaled
      let element_scale_start_height_diff = element_height - element_height_start_scaled

      let xSpacing = screenWidth * 0.07
      let x3Spacing = screenWidth * 0.21

      let centerYearHeight = $('.timeline-element-year').height()


      element_key += 1



      if(breakpoint('screen') > breakpoint('sm')) {

        position += 15

        centerYearHeight = $(window).height() * 0.25

        if($(this).hasClass('element-bottom-left')) {
          startX = containerHalfWidth - element_width + (element_scale_start_width_diff / 2)
          endX = -xSpacing + (element_width_end_scaled / 2) - containerHalfWidth

          startY = (screenHalfHeight - element_height_start_scaled - (centerYearHeight / 2)) * -1
          endY = element_height * 2
        }

        if($(this).hasClass('element-bottom-right')) {
          startX = xSpacing + ((containerHalfWidth - element_width) + (element_scale_start_width_diff / 2)) * -1
          endX = x3Spacing + containerHalfWidth - (element_width_end_scaled / 2)

          startY = (screenHalfHeight - element_height_start_scaled - (centerYearHeight / 2)) * -1
          endY = element_height * 2
        }

        if($(this).hasClass('element-top-right')) {
          startX = xSpacing + ((containerHalfWidth - element_width) + (element_scale_start_width_diff / 2)) * -1
          endX = x3Spacing + containerHalfWidth - (element_width_end_scaled / 2)

          startY = (screenHalfHeight - element_height_start_scaled - (centerYearHeight / 2))
          endY = element_height * -2
        }

         if($(this).hasClass('element-top-left')) {
          startX = containerHalfWidth - element_width + (element_scale_start_width_diff / 2)
          endX = -xSpacing + ((element_width_end_scaled / 2) - containerHalfWidth)

          startY = (screenHalfHeight - element_height_start_scaled - (centerYearHeight / 2))
          endY = element_height * -2 //scaled height out of screen

        }


        timeline.fromTo(this, { opacity: 0}, { opacity: 1, duration: 20 }, position)
        timeline.fromTo(this, { scale: elementStartScale },{ scale: elementEndScale, ease: customEase, duration: 100 }, position)
        timeline.fromTo(this,{ x: startX, y: startY },{ x: endX, y: endY, ease: customEase, duration: 100 }, position)


      } else {

        position += 25

        centerYearHeight = $(window).height() * 0.15

        let xPos = element_width_end_scaled - containerHalfWidth - (element_scale_end_width_diff / 2)

        if($(this).hasClass('mobile-top-right')) {
          startX = ((containerHalfWidth - element_width) + (element_scale_start_width_diff / 2)) * -1
          endX = (screenWidth / 2) + xPos

          startY = (screenHalfHeight - element_height_start_scaled - centerYearHeight) * 1.1
          endY = element_height * -2
        }

        if($(this).hasClass('mobile-bottom-right')) {
          startX = -(screenWidth / 8) + ((containerHalfWidth - element_width) + (element_scale_start_width_diff / 2)) * -1
          endX = xPos

          startY = (screenHalfHeight - element_height_start_scaled - centerYearHeight) * -1 * 1.1
          endY = element_height * 2

        }

        if($(this).hasClass('mobile-bottom-left')) {
          startX = -(screenWidth / 8) + containerHalfWidth - element_width + (element_scale_start_width_diff / 2)
          endX = 0

          startY = (screenHalfHeight - element_height_start_scaled - centerYearHeight) * -1 * 1.1
          endY = element_height * 2
        }

        if($(this).hasClass('mobile-top-left')) {
          startX = containerHalfWidth - element_width + (element_scale_start_width_diff / 2)
          endX = (screenWidth / 8)

          startY = (screenHalfHeight - element_height_start_scaled - centerYearHeight) * 1.1
          endY = element_height * -2
        }

        timeline.fromTo(this, { opacity: 0}, { opacity: 1, duration: 20 }, position)
        timeline.fromTo(this, { scale: elementStartScale },{ scale: elementEndScale, ease: 'none', duration: 100 }, position)
        timeline.fromTo(this,{ x: startX, y: startY },{ x: endX, y: endY, ease: 'none', duration: 100 }, position)

      }

      timeline.to(this, {opacity: 0, duration: 0})


    }


  });

  timelineEndPosition = position

  return {
    timeline: timeline,
    timeHeight: timeline_elements.length * timelineConfig.speed
  };

}

function getTimelineTopPosition()
{
  return parseInt(timelineEndPosition + 100);
}


export { setupTimeline, getTimelineTopPosition }